import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import React from "react";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import FormTextField from "../../../components/formFields/FormTextField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormMultiSelectionFiled from "../../../components/formFields/FormMultiSelectionFiled";
import { setTourItineraryDeleteIndex } from "../quotationSlice";

const TourItineraryArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const TourItineraryDeleteIndex = useAppSelector(
    (state) => state.quotation.TourItineraryDeleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const ItineraryList = useAppSelector((state) => state.itineary.ItinearyList);
  const ItinearyFacilityList = useAppSelector(
    (state) => state.itinearyfacility.ItinearyFacilityList
  );

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("tourItineraryDeleteDialog"));
    dispatch(setTourItineraryDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setTourItineraryDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        DayNo: null,
        ItinaryID: null,
        Description: "",
        Place: null,
        Facilty: "",
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {fieldArrayRenderProps?.value?.length < 1 ? pushElementInarray() : null}
      <GridLayoutItem style={{ marginBottom: 10 }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Tour Itinerary
        </Button>
      </GridLayoutItem>
      {dialogName === "tourItineraryDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Tour Itinerary"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TourItineraryDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((TourItinerary: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card">
              <GridLayout
                style={{ marginRight: 40 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                  { width: "25%" },
                ]}
              >
                <GridLayoutItem
                  colSpan={4}
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "end",
                  }}
                >
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{ height: 28, width: 28 }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "16px" }}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`TourItinerary.${index}.DayNo`}
                    label="Day No"
                    placeholder="Day"
                    type="number"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`TourItinerary.${index}.Place`}
                    label="City"
                    placeholder="i.e. Ahmedabad"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name={`TourItinerary.${index}.ItinaryID`}
                    label={"Itinerary"}
                    placeholder="Itinerary"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={ItineraryList.map((itineary: any) => {
                      return {
                        value: itineary?.ID,
                        label: itineary?.ItineraryTitle,
                      };
                    })}
                  />
                </GridLayoutItem>
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name={`TourItinerary.${index}.Facilty`}
                    label={"Itinerary Facility"}
                    placeholder="Itinerary Facility"
                    component={FormMultiSelectionFiled}
                    // validator={requiredArrayValidator}
                    // astrike={true}
                    isSelectAll={true}
                    options={ItinearyFacilityList.map(
                      (itinearyfacility: any) => {
                        return {
                          value: itinearyfacility.ID,
                          label: itinearyfacility.Name,
                        };
                      }
                    )}
                  />
                </GridLayoutItem>
                <GridLayoutItem colSpan={4} style={{ width: "100%" }}>
                  <Field
                    name={`TourItinerary.${index}.Description`}
                    label="Itinerary Description"
                    placeholder="Itinerary Description"
                    component={FormTextField}
                  />
                </GridLayoutItem>
              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default TourItineraryArray;
